import { Injectable, inject } from "@angular/core";
import { JwtHelperService } from "@auth0/angular-jwt";
import { MatDialog } from "@angular/material/dialog";
import { LegalUpdateModalComponent } from "../modules/legal/legal-update-modal/legal-update-modal.component";
import { HttpClient } from "@angular/common/http";
import { MITPService } from "./mitp.service";
import { first, Observable } from "rxjs";
import { LegalDocumentType } from "../interfaces/legal-document-type";
import { LegalDocument } from "../interfaces/legal-document";

@Injectable({
	providedIn: "root",
})
export class LegalService {
	private jwtHelper = inject(JwtHelperService);
	private dialog = inject(MatDialog);
	private httpClient = inject(HttpClient);
	private mitp = inject(MITPService);

	requestCguNotice() {
		this.isCguUptoDate()
			.pipe(first())
			.subscribe((res) => {
				if (!res.cgu) {
					this.showCguNotice();
				}
			});
	}

	showCguNotice() {
		const legalDialog = this.dialog.open(LegalUpdateModalComponent, {
			width: "550px",
			autoFocus: false,
		});

		legalDialog.afterClosed().subscribe(() => {
			legalDialog.close();
			this.updateCgu().pipe(first()).subscribe();
		});
	}

	private updateCgu(): Observable<null> {
		return this.httpClient.put<null>(this.mitp.Users() + "/cgu", null);
	}

	private isCguUptoDate(): Observable<{ cgu: boolean }> {
		return this.httpClient.get<{ cgu: boolean }>(this.mitp.Users() + "/cgu");
	}

	getLegalDocumentType(): Observable<LegalDocumentType[]> {
		return this.httpClient.get<LegalDocumentType[]>(this.mitp.Legal() + "/types");
	}

	createLegalDocumentType(type: LegalDocumentType): Observable<LegalDocumentType> {
		return this.httpClient.post<LegalDocumentType>(this.mitp.Legal() + "/types", type);
	}

	getLegalDocuments(): Observable<LegalDocument[]> {
		return this.httpClient.get<LegalDocument[]>(this.mitp.Legal());
	}

	getCurrentLegalDocument(type: string): Observable<LegalDocument> {
		return this.httpClient.get<LegalDocument>(this.mitp.Legal() + `/current/${type}`);
	}

	createLegalDocument(doc: LegalDocument): Observable<LegalDocument> {
		return this.httpClient.post<LegalDocument>(this.mitp.Legal(), doc);
	}

	updateLegalDocument(doc: LegalDocument): Observable<LegalDocument> {
		return this.httpClient.put<LegalDocument>(this.mitp.Legal() + `/${doc.id}`, doc);
	}

	getPublicLegalDoc(type: string) {
		return this.httpClient.get(this.mitp.Legal() + `/public/${type}`, {
			responseType: "text",
		});
	}
}
